<template>
  <div v-if="loaded === true">
    <v-dialog
      v-model="confirmDelete"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Delete Weight?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(true)"
          >
            Yes, Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert
      v-model="alert"
      outline
      type="success"
    >{{alertMessage}}</v-alert>
    <v-toolbar :color='getColor("WT")' light dense>
      <v-icon @click="goBack">chevron_left</v-icon>
      <v-btn color="primary" @click="generatePDF">PDF</v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>WeighTag {{ weightag.tagId + 5000}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn :disabled='!isStaff()' color="primary" @click="saveWeighTag">SAVE</v-btn>
    </v-toolbar>
    <v-container fluid grid-list-xl>
      <v-layout row>
        <v-flex xs4>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
          <v-text-field
            slot="activator"
            label="Date:"
            :value="prettyDate(weightag.date)"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="weightag.date" no-title scrollable v-if="isStaff()">
            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="saveDate(weightag.date)">OK</v-btn>
          </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4>
          <v-select
            v-model ='client'
            :items='clients'
            item-text='CLIENTNAME'
            item-value='CLIENTNAME'
            return-object
            label='Client'
            :readonly="!isStaff()"
          ></v-select>
        </v-flex>
        <v-flex xs4>
          <v-select
            v-model ='weightag.Lot.lotNumber'
            :items='lots'
            item-text='lotNumber'
            item-value='lotNumber'
            return-object
            label='Lot'
            :readonly="!isStaff()"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-select
            v-model ='weightag.VINEYARDID'
            :items='vineyards'
            item-text='name'
            item-value='id'
            return-object
            label='Vineyard'
            :readonly="!isStaff()"
          ></v-select>
        </v-flex>
        <v-flex xs4>
          <v-autocomplete single-line
            v-model ='weightag.variety'
            :items='varietals'
            item-text='name'
            item-value='id'
            label='Varietal'
            :readonly="!isStaff()"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-model = "weightag.clone"
            label="Clone"
            :readonly="!isStaff()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            v-model = "weightag.Location.appellation"
            label="Appellation">
          </v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-model = "weightag.Location.region"
            label="Zone">
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            v-model = "weightag.truckLicense"
            label="Truck License"
            :readonly="!isStaff()"
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-model = "weightag.trailerLicense"
            label="Trailer License"
            :readonly="!isStaff()"
        ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-toolbar>
            <v-flex xs5>
              <h2>Tons: {{ totalWeight() }} -- Bins: {{ totalBins }}</h2>
            </v-flex>
            <v-flex xs2>
              <v-toolbar-title>Weights Detail</v-toolbar-title>
            </v-flex>
            <v-flex xs5></v-flex>
            <v-dialog v-model="dialog" max-width="500px" :disabled="!isStaff()">
              <v-card>
                <v-card-title v-if='editedIndex === -1'><span class="headline">NEW WEIGHT</span></v-card-title>
                <v-card-title v-else><span class="headline">EDIT WEIGHT</span></v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs4>
                        <v-text-field v-model="editedItem.weight" type="number" label="Weight"></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field v-model="editedItem.tare" type="number" label="Tare"></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field v-model="editedItem.binCount" type="number" label="Bin Count"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea v-model="editedItem.misc" label="Miscellaneous"></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click.native="close">Cancel</v-btn>
                  <v-btn color="primary" flat @click.native="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card>
            <v-data-table
              :headers='headers'
              :items='weightag.BinDetails'
              hide-actions>
              <template v-slot:items="props">
                <tr>
                  <td width="50px"></td>
                  <td class="text-xs-right" width="50px">{{ formattedNumber(props.item.weight) }}</td>
                  <td class="text-xs-right" width="50px">{{ formattedNumber(props.item.tare) }}</td>
                  <td class="text-xs-right" width="50px">{{ formattedNumber(net(props.item)) }}</td>
                  <td class="text-xs-right" width="50px" >{{ props.item.binCount }}</td>
                  <td width=300px>{{ props.item.misc }}</td>
                  <td width=100px class="justify-end">
                    <v-icon v-if="isStaff()"
                      color="primary"
                      small
                      class="mr-2"
                      @click="editItem(props.item)"
                    >
                      edit
                    </v-icon>
                    <v-icon v-if="isStaff()"
                      color="alert"
                      small
                      @click="deleteItem(props.item)"
                    >
                      delete
                    </v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <hr>
            <br>
            <table v-if="isStaff()">
              <tr>
                <td width="150px">Add New Weight:</td>
                <td width="90px"><input ref="newWeight" v-on:click="newWeightClicked" v-on:keyup.enter="addWeight" size="5" v-model.number="newWeight"></td>
                <td width="105px"><input ref="newTare" v-on:click="newTareClicked" v-on:keyup.enter="addWeight" size="5" v-model.number="newTare"></td>
                <td width="122px">{{ this.newNet }}</td>
                <td width="60px"><input ref="newCount" v-on:click="newCountClicked" v-on:keyup.enter="addWeight" size="5" v-model.number="newBinCount"></td>
                <td width="20px"><input v-on:keyup.enter="addWeight" size="50" v-model.number="newMisc"></td>
                <td width=200px></td>
                <td width=100px class="justify-end">
                  <v-btn @click="addWeight" color='primary'>Add Weight</v-btn>
                    <!-- <v-icon v-if="isStaff()"
                      color="primary"
                      small
                      class="mr-2"
                      @click="addWeight"
                    >
                      add
                    </v-icon> -->
                    </td>
              </tr>
            </table>
            <br>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import myMixins from '../mixins/myMixins'
import { setTimeout } from 'timers'

export default {
  data () {
    return {
      menu: false,
      alert: false,
      alertMessage: '',
      confirmDelete: false,
      fontList: {},
      loaded: false,
      editedIndex: -1,
      newWeight: 0,
      newTare: 184,
      newBinCount: 2,
      newMisc: '',
      newNet: 0,
      editedItem: {
        weight: 0,
        tare: 184,
        binCount: 2,
        misc: ''
      },
      headers: [ { sortable: false },
        { text: 'WEIGHT', value: 'weight', sortable: false, align: 'right' },
        { text: 'TARE', value: 'tare', sortable: false, align: 'right' },
        { text: 'NET', value: 'net', sortable: false, align: 'right' },
        { text: 'BIN COUNT', value: 'binCount', sortable: false, align: 'right' },
        { text: 'MISC', value: 'misc', sortable: false },
        { text: 'ACTIONS', value: 'actions', sortable: false }
      ],
      dialog: false,
      showSection: '',
      weightag: {},
      binHeaders: [{ text: 'WEIGHT', value: 'weight', sortable: false },
        { text: 'TARE', value: 'tare', sortable: false },
        { text: 'BIN COUNT', value: 'binCount', sortable: false },
        { text: 'MISCELLANEOUS', value: 'misc', sortable: false }]
    }
  },
  mixins: [myMixins],
  created () {
    this.retrieveWeighTag()
  },
  methods: {
    newWeightClicked () {
      this.$refs.newWeight.value = ''
    },
    newTareClicked () {
      this.$refs.newTare.value = ''
    },
    newCountClicked () {
      this.$refs.newCount.value = ''
    },
    generatePDF () {
      let url = process.env.VUE_APP_BACKEND + 'weightags/' + this.weightag.id + '?pdf=true'
      console.log(url)
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      )
    },
    totalWeight () {
      return this.roundTons(this.weightag.totalWeight / 2000)
    },
    formattedNumber (number) {
      return number.toLocaleString()
    },
    net (item) {
      return item.weight - item.tare
    },
    saveWeighTag () {
      this.weightag.date = moment(this.weightag.date).startOf('day').add(6, 'hours')
      axios
        .put(process.env.VUE_APP_BACKEND+'weightags/'+this.weightag.id, this.weightag)
        .then(response => {
          this.showAlert('Weigh Tag Updated Successfully')
          this.retrieveWeighTag()
        })
    },
    doConfirmDelete (doIt) {
      this.confirmDelete = false
      if (doIt) {
        axios
          .delete(process.env.VUE_APP_BACKEND+'bindetails/'+ this.editedItem.id)
          .then(response => {
            this.showAlert('Weight Deleted Successfully')
            this.retrieveWeighTag()
          })
      }
    },
    deleteItem (item) {
      this.confirmDelete = true
      this.editedItem = item
    },
    editItem (item) {
      this.editedIndex = this.weightag.BinDetails.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    showAlert (message) {
      this.dialog = false
      this.editedIndex = -1
      this.editedItem = {}
      this.alertMessage = message
      this.alert = true
      let $this = this
      setTimeout(function () {
        $this.alert = false
      }, 1000)
    },
    saveDate (date) {
      this.weightag.date = moment(date).add(5, 'hours').format('YYYY-MM-DDThh:mm:ss')
      this.menu = false
    },
    addWeight () {
      console.log('add new weight')
      let body = {
        weight: this.newWeight,
        tare: this.newTare,
        misc: this.newMisc,
        binCount: this.newBinCount,
        weightag: this.weightag.id
      }
      axios
        .post(process.env.VUE_APP_BACKEND+'bindetails', body)
        .then(response => {
          this.newWeight = 0
          this.newTare = 184
          this.newBinCount = 2
          this.newMisc = ''
          this.showAlert('Weight Added Successfully')
          this.retrieveWeighTag()
        })
    },
    save () {
      this.editedItem.weight = parseInt(this.editedItem.weight)
      this.editedItem.tare = parseInt(this.editedItem.tare)
      this.editedItem.binCount = parseInt(this.editedItem.binCount)
      this.editedItem.weightag = this.weightag.id
      if (this.editedIndex > -1) {
        axios
          .put(process.env.VUE_APP_BACKEND+'bindetails/'+ this.editedItem.id, this.editedItem)
          .then(response => {
            this.showAlert('Weight Modified Successfully')
            this.retrieveWeighTag()
          })
      } else {
      // Must be a new weight
        axios
          .post(process.env.VUE_APP_BACKEND+'bindetails', this.editedItem)
          .then(response => {
            this.showAlert('Weight Added Successfully')
            this.retrieveWeighTag()
          })
      }
    },
    close () {
      this.dialog = false
      this.editedIndex = -1
    },
    retrieveWeighTag () {
      if (this.$route.params.id === '-1') {
        axios
          .get(process.env.VUE_APP_BACKEND+'scps/' + this.$route.query.scpid)
          .then(response => {
            let scp = response.data.data
            delete this.weightag.id
            this.weightag.clientcode = scp.WorkOrder.Client.clientid
            this.weightag.vineyardid = scp.Location.id
            this.weightag.lot = scp.WorkOrder.Lot.lotNumber
            this.weightag.variety = scp.varietal
            this.weightag.date = scp.WorkOrder.date
            axios
              .post(process.env.VUE_APP_BACKEND+'weightags', this.weightag)
              .then(response => {
                this.weightag.id = response.data.data.id
                this.weightag.tagId = response.data.data.tagId
                this.$route.params.id = response.data.data.id
                axios
                  .get(process.env.VUE_APP_BACKEND+'weightags/' + this.weightag.id)
                  .then(response => {
                    this.weightag = response.data.data
                    this.loaded = true
                  })
              })
          })
      } else {
        axios
          .get(process.env.VUE_APP_BACKEND+'weightags/' + this.$route.params.id)
          .then(response => {
            this.weightag = response.data.data
            this.$store.state.client = response.data.data.Client
            this.loaded = true
          })
      }
    } },
  watch: {
    newWeight: function (nv, ov) {
      this.newNet = this.newWeight - this.newTare
    },
    newTare: function (nv, ov) {
      this.newNet = this.newWeight - this.newTare
    }
    // globalChange: function (nv, ov) {
    //   this.$router.push({
    //     path: '/lots'
    //   })
    // }
  },
  computed: {
    totalBins () {
      let total = 0
      this.weightag.BinDetails.forEach(bin => {
        total += bin.binCount
      })
      return total
    },
    estimatedTons: {
      get: function () {
        return this.workOrder.SCPs[0].estimatedTons
      },
      set: function (value) {
        this.workOrder.SCPs[0].estimatedTons = value
      }
    },
    estDaysInTank: {
      get: function () {
        return this.workOrder.SCPs[0].estDaysInTank
      },
      set: function (value) {
        this.workOrder.SCPs[0].estDaysInTank = value
      }
    },
    sulphurPPM: {
      get: function () {
        return this.workOrder.SCPs[0].sulphurPPM
      },
      set: function (value) {
        this.workOrder.SCPs[0].sulphurPPM = value
      }
    },
    // globalChange () {
    //   return (
    //     JSON.stringify(this.$store.state.user) +
    //     JSON.stringify(this.$store.state.client) +
    //     this.$store.state.vintage
    //   )
    // },
    labTestsAndResults () {
      if (this.workOrder.LabTests.length > 0) {
        return this.workOrder.LabTests[0].LabResults
      } else {
        return [{ labTest: 'ABC', value1: '123' }]
      }
    },
    vineyards () {
      return this.$store.state.vineyards
    },
    varietals () {
      return this.$store.state.varietals
    },
    activeLots () {
      return this.$store.state.allActiveLotsForClient
    },
    lots () {
      return this.$store.state.lotsForVintage
    },
    clients () {
      return this.$store.state.clients
    },
    client () {
      return this.$store.state.client
    },
    id () {
      return this.$route.params.id
    }
  }
}
</script>
<style>
input { text-align:right; }
</style>
